import { Dialog, Layout, Text } from '@loadsmart/loadsmart-ui'

import { type Proposal } from '../domain/Proposal'
import { getSubmitAwardedText } from '../presenters/rfpAwardedPresenter'

export type ConfirmAwardDialogProps = {
  rfpId: string
  awardedProposal: Proposal
  isSubmittingAwardConfirmation: boolean
  onConfirm: () => void
  onCancel: () => void
}

export function ConfirmAwardDialog({
  rfpId,
  awardedProposal,
  isSubmittingAwardConfirmation,
  onConfirm,
  onCancel,
}: ConfirmAwardDialogProps) {
  const { leadingText, acceptedText, rejectedText, trailingText } =
    getSubmitAwardedText(awardedProposal)

  function handleConfirm() {
    onConfirm()
  }

  function handleCancel() {
    onCancel()
  }

  return (
    <Dialog scale="small" open>
      <Dialog.Header>Submit response</Dialog.Header>
      <Dialog.Body>
        <Layout.Stack>
          <Text>
            {leadingText} <strong>{acceptedText}</strong>
            <strong>{rejectedText}</strong>
            <br />
            {trailingText}
          </Text>
        </Layout.Stack>
      </Dialog.Body>
      <Dialog.ActionConfirm
        onConfirm={handleConfirm}
        disabled={isSubmittingAwardConfirmation}
        loading={isSubmittingAwardConfirmation}
      >
        Confirm
      </Dialog.ActionConfirm>
      <Dialog.ActionCancel onCancel={handleCancel} disabled={isSubmittingAwardConfirmation}>
        Cancel
      </Dialog.ActionCancel>
    </Dialog>
  )
}
